<template>
  <Modal :open="open" :close="close">
    <div class="px-10 py-5 w-[600px]">
      <h2 class="block uppercase text-center text-blueGray-600 mb-6">
        Enter names for duplicated instances
      </h2>
      <div class="mt-6 flex justify-center flex-col p-4">
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
          >Name for blog post</label
        >
        <input
          v-model="instanceNames['blog']"
          type="text"
          class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
        />
        <p class="text-red-500 text-xs mt-2" v-if="validationStatus.blog">
          Instance name already exist!
        </p>
      </div>
      <div
        v-for="(item, index) in formData.components.filter(
          (i) => i.componentId && i.id
        )"
        :key="index"
        class="mt-6 flex justify-center flex-col bg-gray-100 p-4 rounded"
      >
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
          >Name for section {{ index + 1 }} ({{
            componentNameFormat(item.component)
          }})
        </label>
        <input
          v-model="instanceNames['components'][index]"
          :placeholder="
            getInstanceName(item.componentId, item.id).split('|')[1]
          "
          type="text"
          class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
        />
        <p
          class="text-red-500 text-xs mt-2"
          v-if="validationStatus.components[index]"
        >
          Instance name already exist!
        </p>
      </div>
      <div class="mt-10 flex items-center justify-between">
        <button
          @click="close"
          class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        >
          Cancel
        </button>
        <button
          :disabled="!confirmStatus"
          @click="handleDuplicate"
          :class="
            !confirmStatus
              ? 'bg-gray-200 active:bg-gray-300'
              : 'bg-emerald-500 active:bg-emerald-600'
          "
          class="text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          Confirm
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import Modal from "@/components/Shared/Modal/Base";

export default {
  name: "BlogDuplicateModal",
  components: {
    Modal
  },
  data() {
    return {
      instanceNames: {
        blog: "",
        components: []
      },
      validationStatus: {
        blog: false,
        components: []
      }
    };
  },
  props: {
    close: {
      type: Function,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    formData: {
      type: Object,
      require: true
    },
    instanceName: {
      type: String,
      required: true
    }
  },
  mounted() {
    if (this.formData.components.length && this.instanceName) {
      this.formData.components
        .filter((i) => i.componentId && i.id)
        .forEach((item, index) => {
          this.instanceNames.components[index] =
            this.getInstanceName(item.componentId, item.id).split("|")[1] +
            "_copy";
        });
      this.instanceNames.blog = this.instanceName + "_copy";
    }
  },
  watch: {
    open() {
      if (this.formData.components.length && this.instanceName) {
        this.formData.components
          .filter((i) => i.componentId && i.id)
          .forEach((item, index) => {
            this.instanceNames.components[index] =
              this.getInstanceName(item.componentId, item.id).split("|")[1] +
              "_copy";
          });
        this.instanceNames.blog = this.instanceName + "_copy";
      }
    },
    // Check whether blog name exist
    blogInstanceName() {
      this.checkBlogInstanceExist(
        this.instanceNames.blog,
        this.getComponentId("abi_blog")
      );
    },
    // Check whether child instance name exist
    childComponentInstanceArr: {
      handler: function () {
        if (this.instanceNames.components.length) {
          this.instanceNames.components.forEach((item, index) => {
            this.checkChildInstanceExist(
              item,
              this.formData.components[index].componentId,
              index
            );
          });
        }
      },
      deep: true
    }
  },
  computed: {
    confirmStatus() {
      if (
        this.validationStatus.blog === false &&
        !this.validationStatus.components.filter((item) => {
          return item === true;
        }).length
      ) {
        return true;
      }
      return false;
    },
    blogInstanceName() {
      return this.instanceNames.blog;
    },
    childComponentInstanceArr() {
      return this.instanceNames.components;
    },
    ...mapGetters([
      "getAllComponent",
      "getBlogComponentInstances",
      "getRegion",
      "currentUser"
    ])
  },
  methods: {
    handleDuplicate() {
      this.$store
        .dispatch(Actions.DUPLICATE_BLOG_COMPONENT_INSTANCE, {
          formData: this.formData,
          instanceNames: this.instanceNames,
          region: this.getRegion,
          componentId: this.getComponentId("abi_blog"),
          user: this.currentUser.email
        })
        .then(() => {
          this.$router.push({ path: `/component/blog-page` });
        });
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    },
    componentNameFormat(name) {
      return name.split("_").splice(1).join(" ").toUpperCase();
    },
    getInstanceName(compId, instanceId) {
      if (compId && instanceId) {
        return this.getBlogComponentInstances[compId].find(
          (item) => item.id === instanceId
        ).instance_name;
      }
    },
    checkBlogInstanceExist(name, componentId) {
      if (
        this.getBlogComponentInstances[componentId].find((item) => {
          return item.instance_name === componentId + "|" + name;
        })
      ) {
        this.validationStatus.blog = true;
      } else {
        this.validationStatus.blog = false;
      }
    },
    checkChildInstanceExist(name, componentId, index) {
      if (
        this.getBlogComponentInstances[componentId].find((item) => {
          return item.instance_name === componentId + "|" + name;
        })
      ) {
        this.validationStatus.components[index] = true;
      } else {
        this.validationStatus.components[index] = false;
      }
    }
  }
};
</script>
